/**
 * Credito sponsor: "Sito creato da OdyneAI" con il logo, link a odyneai.com.
 * Usato nel footer della landing, nelle pagine dei centri (AuthShell) e nelle
 * aree loggate di clienti e staff (DashboardShell).
 */
export const OdyneCredit = ({ className = "" }) => (
  <a
    href="https://odyneai.com"
    target="_blank"
    rel="noopener noreferrer"
    data-testid="odyne-credit"
    className={`group inline-flex items-center gap-2 text-xs text-[#737373] hover:text-[#1A1A1A] transition-colors ${className}`}
  >
    <span>Sito creato da</span>
    <img
      src="/odyne-logo-full.png"
      alt="OdyneAI"
      className="h-8 w-8 object-contain transition-transform group-hover:scale-110"
    />
    <span className="font-semibold bg-gradient-to-r from-[#5B8DEF] to-[#A855F7] bg-clip-text text-transparent">
      OdyneAI
    </span>
  </a>
);
